/*
  Nav item `action` / `resource` must be static strings that match route meta.

  Do NOT call `ability.can(...)` here to choose action at module import time.
  On a cold login the ability singleton still has `initialAbility` (or empty
  session rules) when this file is first evaluated, so items would bake in
  `action: 'manage'`. After login updates abilities, `$can('manage', resource)`
  still fails for users who only have `read` → empty sidebar until hard refresh
  (when this module is evaluated again with userData already in localStorage).

  Visibility is decided at render by VerticalNavMenuLink / Group via `$can`.
*/
export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    resource: 'main_dashboard',
    action: 'read',
    children: [
      {
        title: 'Admin',
        route: 'dashboard-admin',
        resource: 'admin_dashboard',
        action: 'read',
      },
      {
        title: 'Revenue',
        route: 'dashboard-revenue',
        resource: 'revenue_dashboard',
        action: 'read',
      },
      {
        title: 'Main',
        route: 'dashboard-main',
        resource: 'main_dashboard',
        action: 'read',
      },
      {
        title: 'Performance',
        route: 'dashboard-performance',
        resource: 'performance_dashboard',
        action: 'read',
      },
      {
        title: 'Power BI',
        route: 'dashboard-power-bi',
        resource: 'powerbi',
        action: 'read',
      },
      {
        title: 'KPMG RPO',
        route: 'dashboard-kpmg-rpo',
        resource: 'kpmg_rpo_dashboard',
        action: 'read',
      },
      {
        title: 'Attendance',
        route: 'dashboard-attendance',
        resource: 'attendance',
        action: 'read',
      },
      {
        title: 'Reliance',
        route: 'dashboard-reliance',
        resource: 'reliance_dashboard',
        action: 'read',
      },
    ],
  },
]
